import { useRef } from 'react';

import { Icon } from '@iconify/react';

import { ContentData } from '../../../types/contentTypes';
import SectionData from '../../../types/SectionData';
import ContentService from '../../../services/contentService';
import clsx from 'clsx';

const cursorGrab = {
  cursor: 'grab',
};

interface ContentListProps {
  contents?: (ContentData | undefined)[];
  handleSwapOrder?: (sections: ContentData[] | SectionData[], index1: number, index2: number) => {};
  className?: string;
}

export default function ContentList({ contents, handleSwapOrder, className }: ContentListProps) {
  const dragItem = useRef<any>(null);
  const dragOverItem = useRef<any>(null);

  const onDragEnd = (e: React.DragEvent<HTMLDivElement>) => {
    handleSwapOrder?.(contents as ContentData[], dragItem.current - 1, dragOverItem.current - 1);
  };

  const contentsRow = contents?.map(content => {
    if (!content) {
      return null;
    }
    return (
      <div
        draggable
        key={content.order}
        onDragStart={() => (dragItem.current = content.order)}
        onDragEnter={() => (dragOverItem.current = content.order)}
        onDragEnd={onDragEnd}
        onDragOver={e => e.preventDefault()}
        className={clsx('flex', className)}
      >
        <Icon icon="material-symbols:menu" className="shrink-0 mr-2 mt-2" style={cursorGrab} />
        <p className="mb-3 overflow-hidden whitespace-nowrap text-ellipsis">
          {ContentService.getContentRowText(content)}
        </p>
      </div>
    );
  });

  return <div className="section-list">{contentsRow}</div>;
}
